import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

// Internal imports
import MobileAppFooter from 'components/common/footer/MobileAppFooter'
import WebFooter from 'components/common/footer/WebFooter'
import SmartLinkComp from 'components/common/smartLinkComp'
import { LanguageContext } from 'context/LanguageContext'
import { ScreenContext } from 'context/ScreenContext'
import { getCurrentCountry, countryCode } from 'utils/appUtils'

const Footer = () => {
    const { strings } = useContext(LanguageContext)

    const { screen } = useContext(ScreenContext)
    const isDesktop = screen >= 992
    const location = useLocation()
    const isLandingPage = location.pathname === '/'
    const siteUnavailable = location.pathname === '/appDownload'
    const ccpaFlag = useSelector(state => state.configuration.get('show_ccpa'))
    const ccprkaFlag = useSelector(state => state.configuration.get('show_ccprka'))
    const ccprkaContentFlag = useSelector(state => state.configuration.get('ccprka_content'))
    const ccprkaUrl = ccprkaContentFlag
        ? ccprkaContentFlag.split('?').shift()
        : strings.LINKS_ccprka
    const isFrom7RewardsView = useSelector(state => state.appSettings.get('isApp'))
    const locationInStore = useSelector(state => state.location)
    const userInStore = useSelector(state => state.user)
    const userCountry = getCurrentCountry(locationInStore, userInStore)
    const caTerms = useSelector(state => state.configuration.getIn(['ca_terms_url']))
    const usTerms = useSelector(state => state.configuration.getIn(['us_terms_url']))
    const caPrivacy = useSelector(state => state.configuration.getIn(['ca_privacy_url']))
    const usPrivacy = useSelector(state => state.configuration.getIn(['us_privacy_url']))
    const termsLink =
        userCountry === countryCode.CA
            ? strings.LINKS_canadaTermsAndConditions
            : strings.LINKS_TermsAndConditions
    const privacyLink =
        userCountry === countryCode.CA
            ? strings.LINKS_canadaPrivacyPolicy
            : strings.LINKS_PrivacyPolicy

    const renderDownloadAppComponent = () => {
        return (
            <div className="container-fluid">
                <div className="row download-app-footer">
                    <div className="col-12">
                        <SmartLinkComp
                            title={strings.downloadTitle}
                            subtitle={strings.downloadSubtitle}
                            inFooter={false}
                        />
                    </div>
                </div>
            </div>
        )
    }

    return !siteUnavailable ? (
        <footer className="app-footer">
            <div className="app-footer-content container-fluid">
                {isFrom7RewardsView ? (
                    <MobileAppFooter userCountry={userCountry} />
                ) : (
                    <WebFooter
                        ccpaFlag={ccpaFlag}
                        ccprkaFlag={ccprkaFlag}
                        ccprkaUrl={ccprkaUrl}
                        userCountry={userCountry}
                        termsLink={termsLink}
                        privacyLink={privacyLink}
                    />
                )}
            </div>
        </footer>
    ) : (
        <div />
    )
}

export default Footer
